<template>
  <div class="md-layout md-alignment-top-center md-gutter">
    <LightBox
      :images="lightImages"
      ref="lightbox"
      :show-caption="false"
      :show-light-box="false"
      :site-loading="imageLoading"
    ></LightBox>
    <template v-if="fetchedSinister && fetchedQuantification && isCP && !loading">
      <div class="md-layout-item md-size-100">
        <RequirementsTable
          :casualty="casualty"
          :roadSinister="fetchedSinister"
          :quantification="fetchedQuantification"
          :payload="payload"
          @seeRequirementInfo="seeRequirementInfo"
        />
      </div>
    </template>
    <div v-else-if="fetchedSinister && !isCP && !loading">
      <loading-content
        slot="empty-state"
        class="md-accent"
        empty-icon="report_problem"
        empty-label="Proceso incorrecto"
        :empty-description="`El siniestro se encuentra en ${process.name}`"
      />
    </div>
    <div v-else-if="!fetchedSinister && !loading">
      <loading-content
        slot="empty-state"
        class="md-accent"
        empty-icon="highlight_off"
        empty-label="Problema al cargar la página"
      />
    </div>
    <div class="md-layout-item md-layout md-alignment-center-right md-size-100">
      <md-button
        v-if="fetchedSinister && !loading"
        :to="{
          name: 'Ficha de Siniestro Carretero',
          params: {
            id: this.fetchedSinister.id,
          },
        }"
      >Ir a ficha de siniestro</md-button>
      <template v-if="fetchedSinister && fetchedQuantification && isCP && !loading">
        <md-button
          v-if="$can('delete', 'Quantification', 'closeprojectvalidations')"
          @click="dialogReject = true"
          class="md-danger"
        >RECHAZAR</md-button>
        <md-button
          v-if="$can('add', 'Quantification', 'closeprojectvalidations')"
          :disabled="!enableFinish"
          @click="finishCP"
          class="md-success"
        >Terminar Cierre de proyecto</md-button>
      </template>
    </div>

    <FilesModal :dialog="dialogFiles" @closeDialog="closeDialog">
      <template v-slot:content>
        <BudgetTable
          v-if="currentRequirementInfo.quantification"
          :currencies="fetchedCurrencies"
          :casualty="casualty"
          :roadSinister="fetchedSinister"
          :quantification="fetchedQuantification"
        />

        <FilesTab
          v-if="
            currentRequirementInfo.fileTypes &&
            !!currentRequirementInfo.fileTypes.length
          "
          :fileTypes="fileTypes"
          :loadedFiles="files"
          @openVisor="openVisor"
        />
      </template>
    </FilesModal>

    <RejectDialog :dialog="dialogReject" @closeDialog="dialogReject = false" @rejectCP="rejectCP" />
  </div>
</template>

<script>
import FilesModal from "./FilesModal.vue";
import RequirementsTable from "./requirementsTable.vue";
import FilesTab from "./FilesTab";
import BudgetTable from "./BudgetTable";
import RejectDialog from "./RejectDialog";

import LightBox from "vue-image-lightbox";
import imageLoading from "@/assets/images/loading.gif";

import sinisterService from "@/services/sinister";
import { sendRequirements, rejectCP } from "@/services/sinister/closeProject";
import fileService from "@/services/Files";
import purchaseService from "@/services/purchase";
import workplanService from "@/services/workPlan";
import catalogService from "@/services/catalog";
import { CP_PROCESS_NUMBER } from "@/utils/ProcessNumbersConst";

export default {
  name: "CloseProject",
  components: {
    RequirementsTable,
    FilesModal,
    LightBox,
    FilesTab,
    BudgetTable,
    RejectDialog,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: "",
    },
  },
  data() {
    return {
      fetchedFileTypes: [],
      fetchedCurrencies: [],
      fetchedSinister: null,
      fetchedQuantification: null,
      loading: true,
      dialogFiles: false,
      dialogReject: false,
      currentRequirementInfo: {},
      files: {},
      requiredFiles: {},
      payload: {
        buildProcess: false,
        materialsQuantity: false,
        securityTools: false,
        projectYield: false,
        rescueMatches: false,
      },
      lightImages: [],
      imageLoading,
    };
  },
  computed: {
    fileTypes() {
      const { fileTypes = [] } = this.currentRequirementInfo;
      return this.fetchedFileTypes
        .filter((t) => fileTypes.some((a) => a === t.codename))
        .map((t) => {
          const { codename } = t;
          const imageTypes = [
            "damage",
            "process",
            "endend",
            "security",
            "RETSAL",
            "ALMSAL",
          ];
          if (imageTypes.some((t) => t === codename)) {
            return {
              ...t,
              type: "image",
            };
          }
          return { ...t };
        });
    },
    fileTypesRequired() {
      const allowTypes = ["BTCF", "GOF"];
      return this.fetchedFileTypes
        .filter((t) => allowTypes.some((a) => a === t.codename))
        .sort(
          (a, b) =>
            allowTypes.indexOf(a.codename) - allowTypes.indexOf(b.codename)
        )
        .map((t) => {
          const { codename } = t;
          switch (codename) {
            default:
              return {
                ...t,
                allowedFormats: ["pdf"],
                disableCharge: (files) =>
                  !!files[codename] && !!files[codename].length,
              };
          }
        });
    },
    isCP() {
      const { process } = this;
      if (process) {
        const processNum = process.number;
        return processNum === CP_PROCESS_NUMBER;
      }
      return false;
    },
    casualty() {
      if (this.fetchedSinister) {
        const { affected } = this.fetchedSinister;
        return affected;
      }
      return {};
    },
    process() {
      if (this.fetchedSinister) {
        const { affected } = this.fetchedSinister;
        return affected.process;
      }
      return "";
    },
    enableFinish() {
      const keys = Object.keys(this.payload);
      return !keys.some((k) => !this.payload[k]);
    },
  },
  methods: {
    seeRequirementInfo(info) {
      this.currentRequirementInfo = info;
      this.dialogFiles = true;
    },
    openVisor(image) {
      const imageDisplay = {
        thumb: image.file,
        src: image.file,
      };
      this.lightImages = [imageDisplay];
      this.$refs.lightbox.showImage(0);
    },
    saveChanges(files = [], reject = [], visible = []) {
      this.$confirmMessage(
        { title: "Confirme que desea guardar los cambios en los documentos" },
        () => {
          let p1 = () =>
            files.length
              ? files.map((c) =>
                  fileService.create({ ...c, affected: this.casualty.id })
                )
              : [];
          let p2 = () =>
            reject.length
              ? reject.map((c) => fileService.delete({ id: c }))
              : [];
          let p3 = () =>
            visible.length && workplanService.updateCustomerVisibility(visible);

          const promise = new Promise((resolve) => {
            Promise.all([...p1(), p2(), p3()])
              .then(() => {
                this.$successMessage({ text: "Cambios guardados" });
                fileService
                  .fetch("file/getfile", {
                    id: this.casualty.id,
                    noStore: true,
                    collection: true,
                  })
                  .then((res) => {
                    const files = this.fileTypesRequired.reduce((ac, a) => {
                      const filteredFiles = res
                        .filter((f) => f.codename === a.codename)
                        .sort((a, b) => a.id - b.id);
                      return { ...ac, [a.codename]: filteredFiles };
                    }, {});
                    this.requiredFiles = Object.assign(
                      {},
                      this.requiredFiles,
                      files
                    );
                  })
                  .finally(() => {
                    resolve();
                  });
              })
              .catch(this.$fireErrorResponse);
          });
          return promise;
        }
      );
    },
    finishCP() {
      this.$confirmMessage(
        { title: "¿Terminar el proceso?", text: "El siniestro avanzará a ADO" },
        () => {
          const promise = new Promise((resolve) => {
            sendRequirements(this.casualty, {
              ...this.payload,
              quantification: this.fetchedQuantification.id,
            })
              .then(() => {
                this.goToSinisterFile();
                this.$successMessage({ text: "Proceso terminado" });
                resolve();
              })
              .catch(this.$fireErrorResponse);
          });
          return promise;
        }
      );
    },
    closeDialog() {
      this.currentConcept = {};
      this.dialogFiles = false;
    },

    rejectCP(comment) {
      return this.$confirmMessage(
        {
          title: "¿Realmente desea rechazar el cierre de proyecto?",
          text: "El proceso regresará a ES/ES",
        },
        () => {
          const promise = new Promise((resolve) => {
            rejectCP({
              quantification: this.fetchedQuantification.id,
              comment,
            })
              .then(() => {
                this.goToSinisterFile();
                this.$successMessage({ text: "Proceso rechazado" });
                resolve();
              })
              .catch(this.$fireErrorResponse);
          });
          return promise;
        }
      );
    },
    securityTransformer({ id, photo, date, isRejected, reason }) {
      const name = photo.split("/").pop();
      return {
        id,
        file: photo,
        addDate: date,
        isRejected,
        name,
        reasonName: reason.name,
        fileType: "security",
      };
    },
    goToSinisterFile() {
      this.$router.push({
        name: "Ficha de Siniestro Carretero",
        params: {
          id: this.fetchedSinister.id,
        },
      });
    },
  },
  mounted() {
    const promise = new Promise((resolve) => {
      Promise.all([
        sinisterService.fetch({ id: this.id }),
        fileService.fetch("filetype"),
        catalogService.fetch("currency"),
      ])
        .then((res) => {
          this.fetchedSinister = { ...res[0] };
          const { affected } = res[0];
          this.fetchedFileTypes = [
            ...res[1],
            {
              codename: "security",
              name: "Fotos de seguridad",
            },
          ].map((t) => {
            if (t.codename === "GO" || t.codename === "GOF") {
              return {
                ...t,
                type: "file",
              };
            }
            return t;
          });
          this.fetchedCurrencies = res[2];
          if (affected) {
            Promise.all([
              fileService.fetch("file/getfile", {
                id: affected.id,
                noStore: true,
                collection: true,
              }),
              purchaseService.fetchQuantification(affected.id),
              workplanService.fetchSecurityPhotos({ affected: affected.id }),
            ]).then((res) => {
              const requiredTypes = [
                "damage",
                "process",
                "endend",
                "security",
                "RETSAL",
                "ALMSAL",
                "GOD",
                "BTCF",
                "GOF",
              ];
              const files = requiredTypes.reduce((ac, a) => {
                const filteredFiles = res[0]
                  .filter((f) => f.codename === a)
                  .sort((a, b) => a.id - b.id);
                return { ...ac, [a]: filteredFiles };
              }, {});
              files.security = res[2].map((f) => this.securityTransformer(f));
              this.files = Object.assign({}, this.file, files);
              this.requiredFiles = Object.assign({}, this.requiredFiles, files);
              this.fetchedQuantification = res[1];
              resolve();
            });
          } else {
            resolve();
          }
        })
        .catch(this.$fireErrorResponse)
        .finally(() => {
          this.loading = false;
        });
    });
    return promise;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/index.vue